<cdk-virtual-scroll-viewport appendOnly itemSize="50" class="viewport-container" #providerElement >
    <ng-content></ng-content>
</cdk-virtual-scroll-viewport>